import { useShallow } from "zustand/react/shallow";

import { Alert } from "@components/molecules/alert/alert";
import { useUIStore } from "@/stores/uiStore";

/**
 * AlertContainer component is used to display alerts in the application.
 * It wraps the main content and renders an Alert component when an alert is triggered.
 * @returns AlertContainer - The rendered AlertContainer component.
 */
export function AlertContainer() {
  const alertProps = useUIStore(useShallow((state) => state.alertProps));

  return (
    <>
      {/* Render the Alert component with the alertProps from the store */}
      <Alert {...alertProps} />
    </>
  );
}
